<template>
    <div
        class="loader"
        :class="[ 'button_' + type ]"
    />
</template>

<script>
export default {
    name: 'Loader',

    props: {
        type: {
            type: String,
            required: false,
            default: 'default'
        }
    },

    data: () => {
        return {}
    },
}
</script>

<style lang='scss' scoped>
$loader-color: #f39200;
$loader-step-1: #f39200;
$loader-step-2: #f39200;
$loader-size: 3rem;
$loader-gap: $loader-size / 4;
$loader-part: ($loader-size - $loader-gap) / 2;
$loader-offset: $loader-part + $loader-gap;

$loader-1: $loader-offset 0 0;
$loader-2: $loader-offset $loader-offset 0;
$loader-3: 0 $loader-offset 0;
$loader-4: -$loader-offset $loader-offset 0;
$loader-5: -$loader-offset 0 0;

$loader-animation: move;
$loader-ease: ease-in-out;

$loader-step: 100 / 4;
$loader-time: 1s;

.loader {
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -$loader-size / 2;
	margin-top: -$loader-size / 2;
	width: $loader-size;
	height: $loader-size;
  color: $loader-color;

	&::before {
		position: absolute;
		width: $loader-part;
		height: $loader-part;
		display: block;
		content: '';
		background: #f39200;
		box-shadow: $loader-1, $loader-2, $loader-3;
		transform-origin: $loader-size / 2 $loader-size / 2;
		animation: $loader-animation $loader-time infinite $loader-ease;
	}

}

@keyframes text {
	30% {
		opacity: 1;
	}
	
	100% {
		opacity: 0;
	}
}

@keyframes move {
	0% {
		transform: translateX(0);
		box-shadow: $loader-1, $loader-2, $loader-3;
	}

	100% {
		transform: translateX($loader-part + $loader-gap);
		box-shadow: $loader-3, $loader-4, $loader-5;
	}
}


</style>